import React from 'react';
import { LockedIcon, UnlockedIcon } from 'assests/GmsIcons';

type TLockSwitchProps = {
    metric: string;
    isLocked: boolean;
    disabled?: boolean;
    toggleLock: (metric: string) => void;
}

const LockSwitch = ({ metric, isLocked, disabled, toggleLock }: TLockSwitchProps) => {
    return (
        <div className="tw-flex tw-items-center tw-justify-center">
            <button disabled={disabled} onClick={() => { if (!disabled) toggleLock(metric) }} className={`focus:tw-outline-none` + !isLocked && disabled ? "tw-opacity-20" : ""}>
                {isLocked ? (<LockedIcon />) : (<UnlockedIcon />)}
            </button>
        </div>
    );
}

export default LockSwitch;